/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { toolsetsGetBySlug } from "../funcs/toolsetsGetBySlug.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { Toolset } from "../models/components/toolset.js";
import {
  GetToolsetRequest,
  GetToolsetSecurity,
} from "../models/operations/gettoolset.js";
import { unwrapAsync } from "../types/fp.js";
export type ToolsetQueryData = Toolset;

export function prefetchToolset(
  queryClient: QueryClient,
  client$: GramCore,
  request: GetToolsetRequest,
  security?: GetToolsetSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildToolsetQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildToolsetQuery(
  client$: GramCore,
  request: GetToolsetRequest,
  security?: GetToolsetSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<ToolsetQueryData>;
} {
  return {
    queryKey: queryKeyToolset({
      slug: request.slug,
      gramSession: request.gramSession,
      gramKey: request.gramKey,
      gramProject: request.gramProject,
    }),
    queryFn: async function toolsetQueryFn(ctx): Promise<ToolsetQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(toolsetsGetBySlug(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyToolset(
  parameters: {
    slug: string;
    gramSession?: string | undefined;
    gramKey?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "toolsets", "getBySlug", parameters];
}
